import api from '@/api'
import Report from '@/api/communique/report'
import types from '@/types'

export interface OTTHoursWatchedStat {
  stat_date: string
  hours_watched: number
}

export interface queryParams {
  startDate?: string
  endDate?: string
  initiativeId?: string
  mediaTypes: string[]
  excludeLineItemIds?: string[]
  includeLineItemIds?: string
}

export class CampaignOTTHoursWatchedStatsModel {
  public async fetchAll({
    initiativeId,
    mediaTypes,
    startDate,
    endDate,
    excludeLineItemIds,
    includeLineItemIds,
  }: queryParams): Promise<Report<OTTHoursWatchedStat>> {
    return api('report.dashboards.ihmCampaign.v2.ott.hourWatched')
      .params({
        initiativeId: initiativeId,
        media_types: mediaTypes,
        start_date: startDate,
        end_date: endDate,
        exclude_line_item_ids: excludeLineItemIds,
        include_line_item_ids: includeLineItemIds,
      })
      .cache(1000 * types.config.dashboardCacheSeconds())
      .jsonMust<Report<OTTHoursWatchedStat>>()
  }
}
